/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
class DisposableStore {
    constructor() {
        this.disposables = [];
        this._isDisposed = false;
    }
    get isDisposed() { return this._isDisposed; }
    dispose() {
        this.clear();
        this._isDisposed = true;
    }
    add(disposable) {
        if (disposable) {
            this.disposables.push(disposable);
        }
        return disposable;
    }
    remove(disposable) {
        if (!disposable) {
            return disposable;
        }
        const index = this.disposables.indexOf(disposable);
        if (index !== -1) {
            this.disposables.splice(index, 1);
        }
        return disposable;
    }
    clear() {
        for (const disposable of this.disposables) {
            disposable.dispose();
        }
        this.disposables = [];
    }
    leakItems() {
        this.disposables = [];
    }
}
class Disposable {
    constructor() {
        this._store = new DisposableStore();
    }
    dispose() {
        this._store.dispose();
    }
    _register(t) {
        this._store.add(t);
        return t;
    }
    _registerOrDispose(t) {
        if (t) {
            if (this._store.isDisposed) {
                t.dispose();
            }
            else {
                this._store.add(t);
            }
        }
        return t;
    }
}

export { Disposable, DisposableStore };
//# sourceMappingURL=disposables.js.map
